import { ApplicantOfferStatus, ApplicationStatus, IApplyDashboardTabs } from 'types';
import { DefaultDashboardTabIds } from '.';

const standardTabs: IApplyDashboardTabs = Object.freeze({
  ['Pipeline']: [
    { label: 'Leads', id: DefaultDashboardTabIds.LEADS },
    { label: 'Applied', id: DefaultDashboardTabIds.APPLIED },
    { label: 'Draft', id: DefaultDashboardTabIds.DRAFT_OFFERS },
    { label: 'Conditional', id: DefaultDashboardTabIds.CONDITIONAL },
    { label: 'Unconditional', id: DefaultDashboardTabIds.UNCONDITIONAL }
  ],
  ['Outcome']: [
    { label: 'Completed', id: DefaultDashboardTabIds.COMPLETED },
    { label: 'Closed', id: DefaultDashboardTabIds.CLOSED }
  ]
});

const agentTabs: IApplyDashboardTabs = Object.freeze({
  ['Pipeline']: [
    { label: 'Leads', id: DefaultDashboardTabIds.LEADS },
    { label: 'Applied', id: DefaultDashboardTabIds.APPLIED },
    { label: 'Conditional', id: DefaultDashboardTabIds.CONDITIONAL },
    { label: 'Unconditional', id: DefaultDashboardTabIds.UNCONDITIONAL }
  ],
  ['Outcome']: [
    { label: 'Completed', id: DefaultDashboardTabIds.COMPLETED },
    { label: 'Closed', id: DefaultDashboardTabIds.CLOSED }
  ]
});

export const TabIdStageMap = Object.freeze({
  [DefaultDashboardTabIds.LEADS]: [ApplicationStatus.InProgress],
  [DefaultDashboardTabIds.APPLIED]: [ApplicantOfferStatus.Applied],
  [DefaultDashboardTabIds.DRAFT_OFFERS]: [ApplicantOfferStatus.Draft],
  [DefaultDashboardTabIds.CONDITIONAL]: [ApplicantOfferStatus.Conditional],
  [DefaultDashboardTabIds.UNCONDITIONAL]: [ApplicantOfferStatus.Unconditional],
  [DefaultDashboardTabIds.COMPLETED]: [ApplicantOfferStatus.Completed],
  [DefaultDashboardTabIds.CLOSED]: [ApplicantOfferStatus.Rejected, ApplicantOfferStatus.Withdrawn]
});

export const TabIdStageMapForAgent = Object.freeze({
  [DefaultDashboardTabIds.LEADS]: [ApplicationStatus.InProgress],
  [DefaultDashboardTabIds.APPLIED]: [ApplicantOfferStatus.Applied, ApplicantOfferStatus.Draft],
  [DefaultDashboardTabIds.CONDITIONAL]: [ApplicantOfferStatus.Conditional],
  [DefaultDashboardTabIds.UNCONDITIONAL]: [ApplicantOfferStatus.Unconditional],
  [DefaultDashboardTabIds.COMPLETED]: [ApplicantOfferStatus.Completed],
  [DefaultDashboardTabIds.CLOSED]: [ApplicantOfferStatus.Rejected, ApplicantOfferStatus.Withdrawn]
});

export const dashboardTabs = Object.freeze({
  '[UniAdmin]': { tabs: standardTabs, map: TabIdStageMap },
  '[Uni]': { tabs: standardTabs, map: TabIdStageMap },
  '[Admin]': { tabs: standardTabs, map: TabIdStageMap },
  '[Agent]': { tabs: agentTabs, map: TabIdStageMapForAgent },
  '[AgencyAdmin]': { tabs: agentTabs, map: TabIdStageMapForAgent }
});
